import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/hand-pointer': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M358.2 179.4C338.7 154.6 305.5 147.4 278.3 160.3 263.2 144.6 242.1 137.8 221.7 140.6V67C221.7 30.1 192 0 155.4 0S89.1 30.1 89.1 67V228.1C69.2 220.7 45.9 223 27.1 237-2.3 258.8-8.7 300.3 12.5 330.2L122.2 484.2C134.6 501.6 154.7 512 176 512H354.3C385.1 512 411.9 490.5 418.8 460.2L446.3 341.2A67.9-67.9 0 0 1 448 326V242C448 195.2 401.4 162.7 358.2 179.4zM81 279.7L108.1 317.8C117.1 330.4 137.1 324.1 137.1 308.5V67C137.1 41.9 173.7 41.8 173.7 67V242C173.7 250.8 180.9 258 189.7 258H196.6C205.4 258 212.6 250.8 212.6 242V207C212.6 181.9 249.1 181.8 249.1 207V242C249.1 250.8 256.3 258 265.1 258H272C280.8 258 288 250.8 288 242V221C288 195.9 324.6 195.8 324.6 221V242C324.6 250.8 331.7 258 340.6 258H347.4C356.3 258 363.4 250.8 363.4 242 363.4 216.9 400 216.8 400 242V326C400 327.5 399.8 329 399.5 330.4L372.1 449.4C370.1 458 362.8 464 354.3 464H176C170.2 464 164.7 461.1 161.3 456.3L51.6 302.3C37.2 282.1 66.6 259.5 81 279.7zM176.1 400V304C176.1 295.2 182.4 288 190.1 288H196.1C203.9 288 210.1 295.2 210.1 304V400C210.1 408.8 203.9 416 196.1 416H190.1C182.4 416 176.1 408.8 176.1 400zM251.6 400V304C251.6 295.2 257.8 288 265.6 288H271.6C279.3 288 285.6 295.2 285.6 304V400C285.6 408.8 279.3 416 271.6 416H265.6C257.8 416 251.6 408.8 251.6 400zM327 400V304C327 295.2 333.3 288 341 288H347C354.7 288 361 295.2 361 304V400C361 408.8 354.7 416 347 416H341C333.3 416 327 408.8 327 400z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/hand-pointer.js
// module id = /sGP
// module chunks = 144